<template>
  <div class="eu-flex-item eu-basis_12">
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ $t('charge.detail.payment-method.boleto.barcode') }}
    </p>
    <p class="emd-card-grid__line">{{ line || '-' }}</p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodBoletoLine',

  props: {
    line: { required: true }
  }
}
</script>
